import Image from './image'

// this import is easier to find
export { Image as ImageWrapper }

export default Image
